import React from "react";
import DTO from "../../assets/vw/svg/dto.svg";
import VWM from "../../assets/vw/svg/vwm.svg";
import LOGOVW from "../../assets/vw/svg/logos-vw.svg";
import LOGOMARCAS from "../../assets/vw/svg/logo-marcas.svg";

class Footer extends React.Component {
  render() {
    const year = new Date().getFullYear();

    return (
      <React.Fragment>
        <footer className="d-flex align-items-center">
          <div className="d-flex flex-column flex-sm-row w-100 h-100 p-0 justify-content-center justify-content-sm-between">
            <div className={
              `footer-title 
              col-12 col-sm-5 col-md-6 col-lg-6 order-2 order-sm-1 p-0 pl-2`
            }>
              © Volkswagen de México {year}
            </div>
            <div className="col-12 col-sm-7 col-md-6 col-lg-6 order-1 order-sm-2 p-0">
              <div className="d-flex justify-content-center">
                <div className="col-2 col-sm-2 border-right p-0 d-flex justify-content-center">
                  <img src={DTO}  alt="" className="dto-icon-mobile"/>
                </div>
                <div className="col-3 col-sm-3 border-right mr-1 mr-sm-2 mr-lg-3 p-0 d-flex justify-content-center">
                  <img src={VWM}  alt="" className={"vwm-icon-mobile"}/>
                </div>
                <div className="col-3 col-sm-3 p-0 mr-2 d-flex justify-content-center">
                  <img src={LOGOVW}  alt="" className={"logovw-icon-mobile"}/>
                </div>
                <div className="col-3 col-sm-3 p-0 d-flex justify-content-center">
                  <img src={LOGOMARCAS}  alt="" className={"logomarcas-icon-mobile"}/>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
